/* eslint-disable react/no-unescaped-entities */
import { Clock, Phone } from "lucide-react"
import Link from "next/link"

export const ContactUsInfo = () => {
  return (
    <div className=" basis-1/2 bg-white">
      <h2 className="mb-4 text-[16px] font-bold text-title">
        We're here to help!
      </h2>

      <p className="mb-8 text-[16px] text-title">
        Have a question, need support, or just want to say hello? Get in touch
        with us—we'd love to hear from you. Our email:{" "}
        <Link href="mailto:cs@e.kingsyard.com" className="underline">
          cs@e.kingsyard.com
        </Link>
      </p>

      <div className="mb-10 grid grid-cols-1 gap-8 text-title lg_grid-cols-2">
        <div className="rounded-[10px] border border-[#c5c5c5]  p-6">
          <div className="mb-4 flex items-center">
            <Phone className="mr-2 h-5 w-5 text-title" />
            <h3 className="text-[16px] font-semibold">Contact Us</h3>
          </div>
          <p className="text-gray-700 mb-1 font-medium">Telephone:</p>
          <p className="mb-4 text-[16px] font-bold text-title">
            1-800-427-4599
          </p>
        </div>

        <div className="rounded-[10px] border border-[#c5c5c5]  p-6">
          <div className="mb-4 flex items-center">
            <Clock className="mr-2 h-5 w-5 text-title" />
            <h3 className="text-[16px] font-semibold">Business Hours</h3>
          </div>
          <p className="text-gray-700">
            Monday - Friday
            <br />
            <span className="font-medium">9:00 am - 5:00 pm PT</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ContactUsInfo
